

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { StatutoryHolidaySetup } from "../../components/StatutoryHolidaySetup";


export const StatutoryHolidaySetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Statutory Holiday Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Statutory Holiday", navigateTo: "/statutory-holiday" }
      ]}
      mainContents={<StatutoryHolidaySetup />}
    />
  );
};
